/* Chesto — Customer Reviews section (v2)
   /assets/section-chesto-reviews.js
   Vanilla JS, no deps. Idempotent. Theme-editor compatible. */

(function () {
  'use strict';

  // Stable gradient palette per author name
  var PALETTES = [
    ['#9583FF', '#3D3568'],
    ['#E89A5C', '#A4521B'],
    ['#4FAD7E', '#1F6E45'],
    ['#E5A332', '#8C5C0F'],
    ['#5A7BFF', '#1E2E73'],
    ['#D86984', '#7A1E36'],
    ['#3FA3B5', '#13525C'],
    ['#A06ED1', '#3F1E63']
  ];
  function gradFor(name) {
    name = name || '';
    var h = 0;
    for (var i = 0; i < name.length; i++) h = ((h << 5) - h + name.charCodeAt(i)) | 0;
    var p = PALETTES[Math.abs(h) % PALETTES.length];
    return 'linear-gradient(135deg, ' + p[0] + ', ' + p[1] + ')';
  }

  // Animated count-up
  function animateNum(el, target, dur) {
    if (!el) return;
    dur = dur || 1400;
    var start = performance.now();
    function tick(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      var v = (target * eased).toFixed(1).replace('.', ',');
      el.textContent = v;
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function init(root) {
    if (!root || root.__crInit) return;
    root.__crInit = true;

    var track   = root.querySelector('[data-cr-track]');
    var cards   = Array.prototype.slice.call(root.querySelectorAll('[data-cr-card]'));
    var chips   = Array.prototype.slice.call(root.querySelectorAll('.cr-chip'));
    var dotsBox = root.querySelector('[data-cr-dots]');
    var scrim   = root.querySelector('[data-cr-scrim]');
    var numEl   = root.querySelector('[data-cr-num]');

    var modalParts = {
      avatar:  root.querySelector('[data-cr-modal-avatar]'),
      stars:   root.querySelector('[data-cr-modal-stars]'),
      author:  root.querySelector('[data-cr-modal-author]'),
      title:   root.querySelector('[data-cr-modal-title]'),
      text:    root.querySelector('[data-cr-modal-text]'),
      product: root.querySelector('[data-cr-modal-product]'),
      mpImg:   root.querySelector('[data-cr-mp-img]'),
      mpName:  root.querySelector('[data-cr-mp-name]'),
      mpPrice: root.querySelector('[data-cr-mp-price]'),
      response:root.querySelector('[data-cr-response]'),
      respText:root.querySelector('[data-cr-response-text]'),
      cta:     root.querySelector('[data-cr-modal-cta]'),
      helpful: root.querySelector('[data-cr-helpful]'),
      hCount:  root.querySelector('[data-cr-helpful-count]')
    };
    var closeBtn = root.querySelector('[data-cr-close]');

    /* ---------- Avatar gradients ---------- */
    cards.forEach(function (card) {
      var av = card.querySelector('[data-cr-avatar]');
      var name = card.getAttribute('data-cr-name') || '';
      if (av && name) av.style.background = gradFor(name);
    });

    /* ---------- Animated rating ---------- */
    if (numEl) {
      var target = parseFloat(numEl.getAttribute('data-target') || '0');
      if (!isNaN(target)) {
        if ('IntersectionObserver' in window) {
          var ioNum = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                animateNum(numEl, target);
                ioNum.disconnect();
              }
            });
          }, { threshold: 0.4 });
          ioNum.observe(numEl);
        } else {
          animateNum(numEl, target);
        }
      }
    }

    /* ---------- Pop-in entrance — cards ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-in'); }, i * 60);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });
      cards.forEach(function (c) { io.observe(c); });
    }
    setTimeout(function () { cards.forEach(function (c) { c.classList.add('is-in'); }); }, 600);

    /* ---------- Pop-in entrance — header elementen (pill, title, sub, stat, filters) ---------- */
    var enterEls = Array.prototype.slice.call(root.querySelectorAll('[data-cr-enter]'));
    if (enterEls.length && 'IntersectionObserver' in window) {
      var ioEnter = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            ioEnter.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      enterEls.forEach(function (el) { ioEnter.observe(el); });
    } else {
      enterEls.forEach(function (el) { el.classList.add('is-in'); });
    }
    // Veiligheidsklep: na 1.2s alsnog tonen
    setTimeout(function () { enterEls.forEach(function (el) { el.classList.add('is-in'); }); }, 1200);

    /* ---------- Filters ---------- */
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-on'); });
        chip.classList.add('is-on');
        var f = chip.getAttribute('data-filter');
        cards.forEach(function (card) {
          var cat = card.getAttribute('data-category') || '';
          card.classList.toggle('is-hidden', f !== 'all' && cat !== f);
        });
        if (track) track.scrollTo({ left: 0, behavior: 'smooth' });
        buildDots();
      });
    });

    /* ---------- Dots ---------- */
    function visibleCards() { return cards.filter(function (c) { return !c.classList.contains('is-hidden'); }); }
    function pageSize() {
      var visible = visibleCards();
      if (!visible.length || !track) return 1;
      var trackW = track.clientWidth;
      var cardW  = visible[0].offsetWidth + 18;
      return Math.max(1, Math.floor(trackW / cardW));
    }
    function buildDots() {
      if (!dotsBox || !track) return;
      var visible = visibleCards();
      var per = pageSize();
      var pages = Math.max(1, Math.ceil(visible.length / per));
      dotsBox.innerHTML = '';
      if (pages <= 1) return;
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.className = 'cr-dot' + (i === 0 ? ' is-on' : '');
        b.type = 'button';
        b.setAttribute('aria-label', 'Pagina ' + (i + 1));
        b.dataset.page = String(i);
        b.addEventListener('click', goToPage);
        dotsBox.appendChild(b);
      }
    }
    function goToPage(e) {
      var idx = parseInt(e.currentTarget.dataset.page, 10) || 0;
      var visible = visibleCards();
      var per = pageSize();
      var target = visible[idx * per];
      if (target && track) {
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    }
    function syncDots() {
      if (!dotsBox || !track) return;
      var dots = Array.prototype.slice.call(dotsBox.querySelectorAll('.cr-dot'));
      if (!dots.length) return;
      var visible = visibleCards();
      if (!visible.length) return;
      var per = pageSize();
      var cardW = visible[0].offsetWidth + 18;
      var current = Math.round(track.scrollLeft / (cardW * per));
      current = Math.max(0, Math.min(dots.length - 1, current));
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === current); });
    }
    if (track) track.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); });
    window.addEventListener('resize', buildDots);
    buildDots();

    /* ---------- Modal ---------- */
    var lastFocus = null;
    var helpfulBase = 0;
    var helpfulOn = false;

    function openModal(card) {
      if (!scrim) return;
      lastFocus = document.activeElement;

      var rating  = parseInt(card.querySelector('.cr-stars').getAttribute('aria-label') || '5', 10) || 5;
      var titleEl = card.querySelector('.cr-card-title') || card.querySelector('.cr-feat-q');
      var bodyTpl = card.querySelector('[data-cr-payload]');
      var name    = card.getAttribute('data-cr-name') || '';
      var prodWrap= card.querySelector('[data-cr-product]');
      var helpEl  = card.querySelector('[data-cr-helpful]');
      var respTpl = card.querySelector('[data-cr-response]');

      modalParts.stars.textContent = '★★★★★☆☆☆☆☆'.slice(5 - rating, 10 - rating);
      var city = prodWrap ? ((prodWrap.querySelector('[data-product-city]') || {}).textContent || '').trim() : '';
      modalParts.author.innerHTML = name + (city ? ' <span style="color:rgba(31,27,50,0.5);font-weight:500">· ' + city + '</span>' : '');
      modalParts.avatar.textContent = (name.trim()[0] || '?').toUpperCase();
      modalParts.avatar.style.background = gradFor(name);
      modalParts.title.textContent = titleEl ? titleEl.textContent.replace(/^["""]+|["""]+$/g, '') : '';
      modalParts.text.innerHTML = bodyTpl ? bodyTpl.innerHTML : '';

      if (prodWrap) {
        var pName = (prodWrap.querySelector('[data-product-name]')  || {}).textContent || '';
        var pPrice= (prodWrap.querySelector('[data-product-price]') || {}).textContent || '';
        var pImg  = (prodWrap.querySelector('[data-product-image]') || {}).textContent || '';
        var pUrl  = (prodWrap.querySelector('[data-product-url]')   || {}).textContent || '#';
        if (pName) {
          modalParts.product.hidden = false;
          modalParts.product.setAttribute('href', pUrl.trim() || '#');
          modalParts.mpName.textContent = pName.trim();
          modalParts.mpPrice.textContent = pPrice.trim();
          if (pImg.trim()) { modalParts.mpImg.src = pImg.trim(); modalParts.mpImg.style.display = ''; }
          else { modalParts.mpImg.removeAttribute('src'); modalParts.mpImg.style.display = 'none'; }
          if (modalParts.cta) modalParts.cta.setAttribute('href', pUrl.trim() || '#');
        } else {
          modalParts.product.hidden = true;
        }
      } else {
        modalParts.product.hidden = true;
      }

      if (respTpl && modalParts.response) {
        modalParts.response.hidden = false;
        modalParts.respText.innerHTML = respTpl.innerHTML;
      } else if (modalParts.response) {
        modalParts.response.hidden = true;
      }

      helpfulBase = helpEl ? (parseInt(helpEl.textContent, 10) || 0) : 0;
      helpfulOn = false;
      modalParts.helpful.classList.remove('is-on');
      modalParts.hCount.textContent = String(helpfulBase);

      scrim.hidden = false;
      void scrim.offsetWidth;
      scrim.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { closeBtn && closeBtn.focus(); }, 80);
    }

    function closeModal() {
      if (!scrim) return;
      scrim.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        scrim.hidden = true;
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }, 240);
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { openModal(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(card); }
      });
    });
    closeBtn && closeBtn.addEventListener('click', closeModal);
    scrim && scrim.addEventListener('click', function (e) { if (e.target === scrim) closeModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && scrim && scrim.classList.contains('is-open')) closeModal();
    });

    modalParts.helpful && modalParts.helpful.addEventListener('click', function () {
      helpfulOn = !helpfulOn;
      modalParts.helpful.classList.toggle('is-on', helpfulOn);
      modalParts.hCount.textContent = String(helpfulBase + (helpfulOn ? 1 : 0));
    });
  }

  function initAll() { document.querySelectorAll('.chesto-reviews').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) {
      e.target.querySelectorAll('.chesto-reviews').forEach(init);
    }
  });
})();
